var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCustomFieldTimeWindows = function SvgCustomFieldTimeWindows(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.19 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#717171;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "time"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_31",
    "data-name": "Enmascarar grupo 31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "reloj-de-pared"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_127",
    "data-name": "Grupo 127"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_126",
    "data-name": "Grupo 126"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_158",
    "data-name": "Trazado 158",
    className: "cls-1",
    d: "M6.09,0a6,6,0,1,0,6,6A6,6,0,0,0,6.09,0Zm0,11.09A5.11,5.11,0,1,1,11.2,6h0A5.12,5.12,0,0,1,6.09,11.11Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_129",
    "data-name": "Grupo 129"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_128",
    "data-name": "Grupo 128"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_159",
    "data-name": "Trazado 159",
    className: "cls-1",
    d: "M8.13,6H6.24V3.38A.44.44,0,0,0,5.8,3a.44.44,0,0,0-.44.43h0V6.44a.44.44,0,0,0,.44.43H8.13a.43.43,0,0,0,.43-.43A.44.44,0,0,0,8.13,6Z"
  }))))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCustomFieldTimeWindows);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "custom_field-time_windows.05ec0c72afec6d79d5dc49c94d44f91e.svg";